const DEMO_HOSTNAME = 'demo.tst.datanomik.com';
const DEMO_BASE = 'https://backentira.vercel.app';

/** Should we override API URLs to the demo backend? Only for demo.tst hostname. */
const shouldOverrideUrls = (): boolean => {
  try {
    return window.location.hostname.includes(DEMO_HOSTNAME);
  } catch {
    return false;
  }
};

/** Is this a demo environment? (UI indicator — badge, limited features, etc.) */
export const isDemo = (): boolean => {
  try {
    if (import.meta.env.VITE_DEMO === 'true') return true;
    if (shouldOverrideUrls()) return true;

    const apiUrl = import.meta.env.VITE_DASHBOARD_API_URL as string;
    if (apiUrl && (apiUrl.includes('backentira') || apiUrl.includes('localhost:3000'))) return true;

    return false;
  } catch {
    return false;
  }
};

export const getApiUrls = () => {
  if (shouldOverrideUrls()) {
    return {
      DASHBOARD_MGR_URL: `${DEMO_BASE}/v1/`,
      DASHBOARD_MGR_JWT_URL: `${DEMO_BASE}/jwt/`,
      DASHBOARD_MGR_API_URL: `${DEMO_BASE}/api/v1/`,
      DASHBOARD_API_URL: `${DEMO_BASE}/api/v1/`,
      BIRT_URL: `${DEMO_BASE}/report-viewer`,
    };
  }

  return {
    DASHBOARD_MGR_URL: import.meta.env.VITE_DASHBOARD_MGR_URL as string,
    DASHBOARD_MGR_JWT_URL: import.meta.env.VITE_DASHBOARD_MGR_JWT_URL as string,
    DASHBOARD_MGR_API_URL: import.meta.env.VITE_DASHBOARD_MGR_API_URL as string,
    DASHBOARD_API_URL: import.meta.env.VITE_DASHBOARD_API_URL as string,
    BIRT_URL: import.meta.env.VITE_BIRT_URL as string,
  };
};

const apiUrls = getApiUrls();

export default apiUrls;
